import { HIRING_REQUEST_STATUS } from "../services/hiringRequestsApi";

const TERMINAL_STATUSES = new Set(["закрыта", "завершена", "отменена", "архив"]);

const STATUS_META = {
    "создана": { tone: "blue", nextAction: "Проверить заявку и взять её на анализ" },
    "на анализе": { tone: "amber", nextAction: "Уточнить условия или утвердить заявку" },
    "утверждена": { tone: "violet", nextAction: "Создать или подготовить связанную вакансию" },
    "опубликована": { tone: "emerald", nextAction: "Контролировать отклики и закрытие мест" },
    "возвращена на уточнение": { tone: "orange", nextAction: "Руководителю необходимо уточнить условия" },
    "закрыта": { tone: "slate", nextAction: "Потребность закрыта" },
    "завершена": { tone: "slate", nextAction: "Работа по заявке завершена" },
    "отменена": { tone: "red", nextAction: "Заявка отменена" },
    "архив": { tone: "slate", nextAction: "Черновик заявки сохранён в архиве" },
};

export function getHiringRequestStatusMeta(status) {
    return {
        label: HIRING_REQUEST_STATUS[status] || status || "Статус не указан",
        tone: STATUS_META[status]?.tone || "slate",
        nextAction: STATUS_META[status]?.nextAction || "Уточнить текущее состояние заявки",
    };
}

export function matchesHiringRequestSearch(request, query) {
    const normalizedQuery = String(query || "").trim().toLocaleLowerCase("ru-RU");
    if (!normalizedQuery) return true;
    const searchable = [
        request?.public_code,
        request?.id,
        request?.position,
        request?.department,
        request?.manager_name,
        request?.initiator_name,
        request?.assigned_hr_name,
        request?.work_address,
    ];
    return searchable.some((value) => String(value ?? "").toLocaleLowerCase("ru-RU").includes(normalizedQuery));
}

export function getHiringRequestDashboardStats(requests) {
    const source = Array.isArray(requests) ? requests : [];
    return source.reduce((result, request) => {
        result.total += 1;
        if (!TERMINAL_STATUSES.has(request?.status)) result.active += 1;
        if (request?.deadline_state === "overdue") result.overdue += 1;
        if (request?.status === "возвращена на уточнение") result.needsClarification += 1;
        const free = Number(request?.slot_summary?.free);
        if (Number.isFinite(free)) result.freePlaces += free;
        else if (!TERMINAL_STATUSES.has(request?.status)) result.freePlaces += Number(request?.headcount) || 0;
        return result;
    }, { total: 0, active: 0, overdue: 0, needsClarification: 0, freePlaces: 0 });
}
